<template>
  <div>
    <b-button
      v-b-toggle="'list-invisible-' + type"
      class="m-1"
      variant="info">{{ title }}</b-button>
    <!--b-row class="align-center mb-4">
      <b-col><b-button v-b-modal.modal-import-participant-list variant="primary">Importer</b-button></b-col>
      <b-modal id="modal-import-participant-list" title="Importer une liste de participants" scrollable hide-footer>
        <form-import-list v-on:sendForm="receiveForm" :id="this.id"></form-import-list>
      </b-modal>
    </b-row-->
    <b-collapse :id="'list-invisible-' + type">
      <b-container>
        <b-modal
          :id="'modal-update-' + type"
          :title="getTitle()"
          hide-footer>
          <form-tag
            :type="type"
            :item="selectedItem"
            @sendForm="receiveUpdate"/>
        </b-modal>
        <b-row>
          <b-col class="text-right mb-2">
            <b-button
              variant="success"
              @click="showModal()">Ajouter</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-table
              :fields="fields"
              :items="items"
              small
              responsive="sm">
              <template
                slot="[item_name]"
                slot-scope="row">
                <b-badge :style="{ 'background-color': row.item.item_color }">{{ row.item.item_name }}</b-badge>
              </template>
              <template
                slot="[update]"
                slot-scope="row">
                <b-button
                  size="sm"
                  variant="primary"
                  @click="showModal(row.item)">Modifier</b-button>
                <b-button
                  size="sm"
                  variant="danger"
                  @click="deleteItem(row.item)">Supprimer</b-button>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-container>
    </b-collapse>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex';
import FormTag from '../forms/FormTag.vue';
import { operationBus } from '../../main';

export default {
  name: 'ListTrainingAssociations',
  components: { FormTag },
  props: {
    type: {
      type: String,
      default: 'tag',
    },
    title: {
      type: String,
      default: 'Liste des tags',
    },
  },
  data() {
    return {
      fields: [
        {
          item_name: {
            label: 'Nom',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          update: {
            label: 'Actions',
            sortable: false,
            tdClass: 'align-middle',
          },
        },
      ],
      filter: null,
      filterOn: [],
      loading: true,
      items: [],
      selectedItem: null,
    };
  },
  computed: mapState({
    needs: state => state.contracts.needs,
    usages: state => state.contracts.usages,
    tags: state => state.establishments.tags,
  }),
  mounted() {
    this.initData();
  },
  methods: {
    ...mapActions({
      getNeeds: 'contracts/getAllNeeds',
      getUsages: 'contracts/getAllUsages',
      getTags: 'establishments/getTags',
    }),
    initData() {
      if (this.type === 'need') {
        this.getNeeds().then(() => {
          this.items = this.needs.map(e => ({ item_id: e.need_id, item_name: e.need_label, item_color: e.need_color }));
        });
      }
      if (this.type === 'usage') {
        this.getUsages().then(() => {
          this.items = this.usages.map(e => ({
            item_id: e.usage_id,
            item_name: e.usage_label,
            item_color: e.usage_color,
          }));
        });
      }
      if (this.type === 'tag') {
        this.getTags().then(() => {
          this.items = this.tags.map(e => ({ item_id: e.tag_id, item_name: e.tag_name, item_color: e.tag_color }));
        });
      }
    },
    receiveUpdate(formTag) {
      const jsonForm = JSON.parse(formTag);
      if (this.type === 'need') {
        const form = { fne_id: jsonForm.item_id, fne_name: jsonForm.item_name, fne_color: jsonForm.item_color ? jsonForm.item_color : '' };
        this.$root.$emit('bv::hide::modal', `modal-update-${this.type}`);
        this.$store.dispatch('contracts/setNeed', form).then(() => this.initData());
      }
      if (this.type === 'usage') {
        const form = { fus_id: jsonForm.item_id, fus_name: jsonForm.item_name, fus_color: jsonForm.item_color ? jsonForm.item_color : '' };
        this.$root.$emit('bv::hide::modal', `modal-update-${this.type}`);
        this.$store.dispatch('contracts/setUsage', form).then(() => this.initData());
      }
      if (this.type === 'tag') {
        const form = { tag_id: jsonForm.item_id, tag_name: jsonForm.item_name, tag_color: jsonForm.item_color ? jsonForm.item_color : '' };
        this.$root.$emit('bv::hide::modal', `modal-update-${this.type}`);
        this.$store.dispatch('establishments/setTag', form).then(() => this.initData());
      }
    },
    showModal(item) {
      this.selectedItem = item;
      this.$root.$emit('bv::show::modal', `modal-update-${this.type}`);
    },
    getTitle() {
      if (this.type === 'need') {
        return this.selectedItem ? 'Modifier un besoin' : 'Ajouter un besoin';
      }
      if (this.type === 'usage') {
        return this.selectedItem ? 'Modifier un usage' : 'Ajouter un usage';
      }
      if (this.type === 'tag') {
        return this.selectedItem ? 'Modifier un tag' : 'Ajouter un tag';
      }
      return '';
    },
    deleteItem(item) {
      let actionMessage = '';
      if (this.type === 'need') {
        actionMessage = `la suppression du besoin : ${item.item_name}`;
      }
      if (this.type === 'usage') {
        actionMessage = `la suppression de l'usage : ${item.item_name}`;
      }
      if (this.type === 'tag') {
        actionMessage = `la suppression du tag : ${item.item_name}`;
      }
      const operation = {
        id: this.type + item.item_id, // TODO : Generate id
        cancel: false,
        action: actionMessage,
        request: `contracts/delete${this.type}`,
        params: { item_id: item.item_id },
      };
      operationBus.$emit('operationAdded', operation);
      operationBus.$on('operationFinished', () => {
        this.initData();
      });
    },
  },
};
/* TODO : - Changement de params : Faire une liste de paramètres possibles
*  TODO : - Changement de nom : on insère si le thème n'existe pas
* */
</script>
<style>
  .badge-sizing {
    font-size: 1rem;
  }
  #list-invisible-training {
    font-size: 0.75em;
  }
</style>
